window.addEventListener('DOMContentLoaded', () => {
  const cross = document.querySelector('.nav__cross');
  const navActive = document.querySelector('.nav__menu');
  cross.addEventListener('click', () => {
    if (!navActive.classList.contains('nav__menu--active')) {
      navActive.classList.add('nav__menu--active');
    } else {
      navActive.classList.remove('nav__menu--active');
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 1024) {
      navActive.classList.remove('nav__menu--active');
    }
  });

  const hasChild = document.querySelector('.menu-item-has-children');
  hasChild.addEventListener('click', () => {
    if (!hasChild.classList.contains('menu-item-has-children--active')) {
      hasChild.classList.add('menu-item-has-children--active');
    } else {
      hasChild.classList.remove('menu-item-has-children--active');
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 1024) {
      hasChild.classList.remove('menu-item-has-children--active');
    }
  });
});
